import { ITeaserEvent, ITeaserItem } from './types';
import { getConfig } from '@cian/config/browser';
import { parseCookies } from '@cian/utils';
import { getViewportDimensions } from '../../utils/getViewportDimensions';

export const sendTeaserEvent = (items: ITeaserItem[]) => {
  const soprApi = getConfig().get<string>('soprApi');
  const abGroup = getConfig().get<number>('abGroup');
  const page = window && window.CianAnalytics ? window.CianAnalytics.service.config.page : {};

  const event: ITeaserEvent = {
    user_id: window.__header_user_id__,
    pageType: page.pageType,
    device_type: page.siteType,
    ab_group: abGroup,
    viewport: getViewportDimensions(),
    cid: parseCookies(document.cookie)['_CIAN_GK'],
    items,
  };

  fetch(`${soprApi}teaser/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(event),
  });
};
